import { CircleX, Mail } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { openEmailPreview } from '~/pages/messages/openEmailPreview';
import type { PriceDeclinedMessage } from '~/pages/messages/Messages';

export function PriceDeclinedCard({
  msg,
}: Readonly<{ msg: PriceDeclinedMessage }>) {
  const { t } = useTranslation('messages');
  const { emailHtmlBody } = msg;

  return (
    <div className="flex flex-col items-center gap-1">
      <span className="text-xs text-neut-400">{msg.timestamp}</span>
      <div className="w-full max-w-md rounded-2xl p-4 border bg-warning-50 border-warning-200">
        <div className="flex items-start gap-3">
          <CircleX size={18} className="text-warning-500 shrink-0 mt-0.5" />
          <div className="flex-1">
            <p className="text-sm font-semibold text-warning-800">
              {t(
                msg.sellerView
                  ? 'messages.price_declined.title_seller'
                  : 'messages.price_declined.title'
              )}
            </p>
            {msg.reason && (
              <p className="text-xs text-neut-500 mt-1">
                <span className="font-medium">
                  {t('messages.price_declined.reason_label')}
                </span>{' '}
                {msg.reason}
              </p>
            )}
            {emailHtmlBody && (
              <button
                onClick={() => openEmailPreview(emailHtmlBody)}
                className="flex items-center gap-1 mt-2.5 px-2.5 py-1 border border-warning-200 rounded-lg text-[10px] text-warning-700 hover:bg-neut-bg-alt transition-colors bg-neut-bg-alt"
              >
                <Mail size={10} />
                {t('messages.price_declined.preview_email')}
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
